import { render } from "./RightMenuItemComponet.vue?vue&type=template&id=6762ef97&scoped=true"
import script from "./RightMenuItemComponet.vue?vue&type=script&lang=js"
export * from "./RightMenuItemComponet.vue?vue&type=script&lang=js"

import "./RightMenuItemComponet.vue?vue&type=style&index=0&id=6762ef97&lang=scss&scoped=true"

import exportComponent from "/Users/yq-qianduan/Documents/yq-home-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6762ef97"]])

export default __exports__